<aside class="sidebar" [class.collapsed]="isCollapsed">
    <div class="sidebar-content" *ngIf="currentUser() as currentUser">
        <!-- Logo Section -->
        <div class="logo-section">
            <img class="collapsed" *ngIf="isCollapsed"
                [src]="isDarkMode() ? 'assets/images/logo-small-dark.png' : 'assets/images/logo-small.png'"
                alt="LogoSmall">
            <img *ngIf="!isCollapsed" [src]="isDarkMode() ? 'assets/images/logo-dark.png' : 'assets/images/logo.png'"
                alt="Logo">
        </div>

        <!-- User Profile Section -->
        <a routerLink="/settings/profile-settings" class="user-section">
            <div class="user-avatar">
                <img [src]="currentUser?.avatar" alt="User" *ngIf="currentUser?.avatar">
                <span class="avatar-initials"
                    *ngIf="!isCollapsed && !currentUser?.avatar">{{getUserInitials(currentUser?.username ??
                    "")}}</span>
                <span class="avatar-initials" *ngIf="isCollapsed && !currentUser?.avatar">{{getUserInitials(currentUser?.username ??
                        "")}}</span>
            </div>
            <div class="user-info" *ngIf="!isCollapsed">
                <h3 class="user-name">{{currentUser?.username}}</h3>
                <p class="user-role">{{currentUser?.role?.name}} {{currentUser?.isDepartmentHead ? 'HEAD' : ''}}</p>
            </div>
        </a>

        <!-- Navigation -->
        <nav class="sidebar-nav">
            <div class="nav-section">
                <h4 class="nav-label" *ngIf="!isCollapsed">PRIMARY</h4>

                <a routerLink="/dashboard" routerLinkActive="active" class="nav-link">
                    <div class="nav-icon">
                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M6.66667 14.6381H13.3333M9.18141 2.77477L3.52949 7.17071C3.15168 7.46456 2.96278 7.61148 2.82669 7.79548C2.70614 7.95847 2.61633 8.14209 2.56169 8.33731C2.5 8.5577 2.5 8.79702 2.5 9.27565V15.3048C2.5 16.2382 2.5 16.7049 2.68166 17.0614C2.84144 17.375 3.09641 17.63 3.41002 17.7898C3.76654 17.9714 4.23325 17.9714 5.16667 17.9714H14.8333C15.7668 17.9714 16.2335 17.9714 16.59 17.7898C16.9036 17.63 17.1586 17.375 17.3183 17.0614C17.5 16.7049 17.5 16.2382 17.5 15.3048V9.27565C17.5 8.79702 17.5 8.5577 17.4383 8.33731C17.3837 8.14209 17.2939 7.95847 17.1733 7.79548C17.0372 7.61148 16.8483 7.46456 16.4705 7.17071L10.8186 2.77477C10.5258 2.54706 10.3794 2.4332 10.2178 2.38944C10.0752 2.35082 9.92484 2.35082 9.78221 2.38944C9.62057 2.4332 9.47418 2.54706 9.18141 2.77477Z"
                                stroke="#737373" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <span class="nav-text" *ngIf="!isCollapsed">Dashboard</span>
                </a>

                <a [routerLink]="'/tasks/'+gettaskDisplayStyle()" routerLinkActive="active" class="nav-link">
                    <div class="nav-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c2.39 0 4.68.94 6.36 2.64"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <span class="nav-text" *ngIf="!isCollapsed">My Tasks</span>
                </a>

                <a routerLink="/leads" routerLinkActive="active" class="nav-link">
                    <div class="nav-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <span class="nav-text" *ngIf="!isCollapsed">Leads</span>
                </a>

                <a routerLink="/opportunities" routerLinkActive="active" class="nav-link">
                    <div class="nav-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <span class="nav-text" *ngIf="!isCollapsed">Opportunity</span>
                </a>

                <a routerLink="/clients" routerLinkActive="active" class="nav-link">
                    <div class="nav-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                        </svg>
                    </div>
                    <span class="nav-text" *ngIf="!isCollapsed">Clients</span>
                </a>

                <a routerLink="/appointments" routerLinkActive="active" class="nav-link">
                    <div class="nav-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor"
                                stroke-width="2" />
                            <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2" />
                            <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2" />
                            <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2" />
                        </svg>
                    </div>
                    <span class="nav-text" *ngIf="!isCollapsed">Appointments</span>
                </a>

                <a routerLink="/email-templates" *ngIf="currentUser?.role?.name === 'ADMIN'" routerLinkActive="active"
                    class="nav-link">
                    <div class="nav-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <line x1="22" y1="2" x2="11" y2="13" stroke="currentColor" stroke-width="2" />
                            <polygon points="22,2 15,22 11,13 2,9 22,2" stroke="currentColor" stroke-width="2" />
                        </svg>
                    </div>
                    <span class="nav-text" *ngIf="!isCollapsed">Email Templates</span>
                </a>

                <!-- Products Section with Submenu (Admin only) -->
                <div class="nav-link-group" *ngIf="authService.hasRole([UserRoleType.ADMIN]) || authService.isDepartmentHead()">
                    <button class="nav-link nav-parent" (click)="toggleSubmenu('products')"
                        [class.active]="isSubmenuActive('products')">
                        <div class="nav-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <polyline points="3.27 6.96 12 12.01 20.73 6.96" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <line x1="12" y1="22.08" x2="12" y2="12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                            </svg>
                        </div>
                        <span class="nav-text" *ngIf="!isCollapsed">Products</span>
                        <div class="nav-arrow" *ngIf="!isCollapsed">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                [class.rotated]="isSubmenuOpen('products')">
                                <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </button>

                    <div class="nav-submenu" *ngIf="!isCollapsed && isSubmenuOpen('products')">
                        <a routerLink="/products" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active" class="nav-link nav-sublink">
                            <div class="nav-icon">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                                    <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                                    <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                                    <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                                </svg>
                            </div>
                            <span class="nav-text">Manage Products</span>
                        </a>
                        <a routerLink="/products/leads" routerLinkActive="active" class="nav-link nav-sublink">
                            <div class="nav-icon">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="2"/>
                                    <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2"/>
                                    <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2"/>
                                    <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="2"/>
                                </svg>
                            </div>
                            <span class="nav-text">Product Leads</span>
                        </a>
                    </div>
                </div>

                <!-- Reports Section with Submenu -->
                <div class="nav-link-group">
                    <button class="nav-link nav-parent" (click)="toggleSubmenu('reports')"
                        [class.active]="isSubmenuActive('reports')">
                        <div class="nav-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                                    stroke="currentColor" stroke-width="2" />
                                <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" />
                                <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2" />
                                <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="2" />
                                <polyline points="10,9 9,9 8,9" stroke="currentColor" stroke-width="2" />
                            </svg>
                        </div>
                        <span class="nav-text" *ngIf="!isCollapsed">Reports</span>
                        <div class="nav-arrow" *ngIf="!isCollapsed">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                [class.rotated]="isSubmenuOpen('reports')">
                                <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </button>

                    <div class="nav-submenu" *ngIf="!isCollapsed && isSubmenuOpen('reports')">
                        <a routerLink="/reports/client-report" routerLinkActive="active" class="nav-link nav-sublink">
                            <div class="nav-icon">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor"
                                        stroke-width="2" />
                                    <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" stroke-width="2" />
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="2" />
                                </svg>
                            </div>
                            <span class="nav-text">Client Report</span>
                        </a>
                        <a routerLink="/reports/sales-report" routerLinkActive="active" class="nav-link nav-sublink">
                            <div class="nav-icon">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" stroke="currentColor"
                                        stroke-width="2" />
                                    <polyline points="17 6 23 6 23 12" stroke="currentColor" stroke-width="2" />
                                </svg>
                            </div>
                            <span class="nav-text">Sales Report</span>
                        </a>
                        <a *ngIf="(currentUser?.role?.name == 'ADMIN' || currentUser?.role?.name == 'MANAGER')"
                            routerLink="/reports/broker-performance" routerLinkActive="active"
                            class="nav-link nav-sublink">
                            <div class="nav-icon">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor"
                                        stroke-width="2" />
                                    <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                                </svg>
                            </div>
                            <span class="nav-text">Broker Performance</span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="nav-section">
                <h4 class="nav-label" *ngIf="!isCollapsed">SECONDARY</h4>
                <a routerLink="/settings" routerLinkActive="active" class="nav-link">
                    <div class="nav-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" />
                            <path
                                d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                                stroke="currentColor" stroke-width="2" />
                        </svg>
                    </div>
                    <span class="nav-text" *ngIf="!isCollapsed">Settings</span>
                </a>
            </div>
        </nav>

        <!-- Bottom Section -->
        <div class="sidebar-footer">
            <button class="get-app-button" (click)="showAppDownloadModal = true" title="Get Mobile App">
                <div class="nav-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <rect x="5" y="2" width="14" height="20" rx="2" stroke="currentColor" stroke-width="2"/>
                        <line x1="12" y1="18" x2="12" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </div>
                <span class="nav-text" *ngIf="!isCollapsed">Get Mobile App</span>
            </button>
            <button class="logout-button" (click)="logout()">
                <span class="nav-text" *ngIf="!isCollapsed">Logout</span>
                <img src="assets/images/sidemenu/logout.png" alt="Logout">
            </button>
        </div>
    </div>
</aside>

<app-download-modal
    *ngIf="showAppDownloadModal"
    (close)="showAppDownloadModal = false">
</app-download-modal>